<template>
  <div class="home">
    <LoaderComponent v-show="loading || payLoading" :loaderText="loaderText" />
    <HeaderView />
    <section
      class="dashboard-page-main-sec order-page-main-sec track-order-main-sec agency-design-grid-right draft-order-page-sec draft-orders-list-page"
    >
      <div class="row">
        <div class="col-md-12">
          <div class="text-heading-2">Draft Orders</div>
          <div class="editor-dashboard-sec-2 approval-list-sec draft-order-sec">
            <div class="order-list-tabs">
              <div class="order-input-field">
                <div class="date-picker-box">
                  <div class="form-row">
                    <div class="col-md-12">
                      <label>Filter by date</label>
                      <div
                        class="input-daterange input-group"
                        id="m_datepicker"
                      >
                        <DatePickerComponent
                          :minDate="minDate"
                          :maxDate="maxDate"
                          :options="options"
                          :position="position"
                          :refVal="'datepickerMenu'"
                          :orderDate="order_date"
                          @getSearchData="getSearchData"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="download-icon-list">
                  <span
                    v-if="showProcessOrders && !canProceedToPayment && !payLoading"
                    class="draft-pay-btn-wrap is-disabled"
                    v-b-tooltip.hover.top="'Select more than one draft order to proceed'"
                  >
                    <button
                      type="button"
                      class="btn btn-primary draft-pay-btn"
                      disabled
                    >
                      Process orders<span v-if="selectedDraftIds.length"> ({{ selectedDraftIds.length }})</span>
                    </button>
                  </span>
                  <span v-else-if="showProcessOrders" class="draft-pay-btn-wrap">
                    <button
                      type="button"
                      class="btn btn-primary draft-pay-btn"
                      :disabled="payLoading"
                      @click="paySelectedDrafts"
                    >
                      Process orders<span v-if="selectedDraftIds.length"> ({{ selectedDraftIds.length }})</span>
                    </button>
                  </span>
                  <div @click="downloadFile()" class="top_icons">
                    <i
                      class="fas fa-file-export"
                      v-b-tooltip.hover.top="'Export CSV'"
                    ></i>
                  </div>
                  <div class="per-page-right-box">
                    <div class="select-item">
                      <select
                        @change="changePagination()"
                        v-model="filter.per_page"
                      >
                        <option>50</option>
                        <option>100</option>
                        <option>200</option>
                        <option>500</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <DraftOrderView
              :draft_orders="draft_orders"
              :enableMultiSelect="true"
              :selectedDraftIds="selectedDraftIds"
              @update:selectedDraftIds="selectedDraftIds = $event"
            />
            <div v-if="showProcessOrders" class="draft-pay-bottom-bar">
              <span
                v-if="!canProceedToPayment && !payLoading"
                class="draft-pay-btn-wrap is-disabled"
                v-b-tooltip.hover.top="'Select more than one draft order to proceed'"
              >
                <button
                  type="button"
                  class="btn btn-primary draft-pay-btn"
                  disabled
                >
                  Process orders<span v-if="selectedDraftIds.length"> ({{ selectedDraftIds.length }})</span>
                </button>
              </span>
              <span v-else class="draft-pay-btn-wrap">
                <button
                  type="button"
                  class="btn btn-primary draft-pay-btn"
                  :disabled="payLoading"
                  @click="paySelectedDrafts"
                >
                  Process orders<span v-if="selectedDraftIds.length"> ({{ selectedDraftIds.length }})</span>
                </button>
              </span>
            </div>
            <div class="total-records-list">
              <p>Showing {{ draft_orders.length }} of {{ totalRecords }} records</p>
            </div>
          </div>
        </div>
      </div>
      <div class="pagination-list">
        <paginate
          :click-handler="getDraftOrder"
          :prev-text="'Prev'"
          :next-text="'Next'"
          :page-count="filter.last_page"
          :page-range="3"
          :margin-pages="2"
          :container-class="'className'"
          :records="totalRecords"
          v-model="filter.page"
          :per-page="filter.per_page"
        >
        </paginate>
      </div>
    </section>
  </div>
</template>

<script>
import HeaderView from "@/components/layout/HeaderComponent.vue";
import LoaderComponent from "@/components/LoaderComponent.vue";
import DraftOrderView from "@/components/dashboardComponents/draftOrder.vue";
import Paginate from "vuejs-paginate-next";
import DatePickerComponent from "@/components/DatePickerComponent.vue";
import { useToast } from "vue-toastification";
import { validateDraftOrder } from "@/utils/draftOrderPayValidation.js";
import { getDraftLinksCount } from "@/utils/draftOrderListHelpers.js";
import swal from "sweetalert2";
const toast = useToast();

export default {
  components: {
    DatePickerComponent,
    HeaderView,
    LoaderComponent,
    DraftOrderView,
    Paginate,
  },
  mounted() {
    this.getDraftOrder();
  },
  data() {
    return {
      loading: false,
      loaderText: "",
      options: {
        format: "MM/DD/YYYY",
        useCurrent: false,
      },
      order_date: "",
      minDate: new Date(new Date().setMonth(new Date().getMonth() - 1)),
      maxDate: new Date(new Date().setMonth(new Date().getMonth() + 1)),
      filter: {
        s: "",
        e: "",
        columnTo: "id",
        orderBy: "desc",
        per_page: 50,
        page: 1,
        last_page: 1,
      },
      totalRecords: 0,
      draft_orders: [],
      position: "left",
      selectedDraftIds: [],
      payLoading: false,
    };
  },
  computed: {
    showProcessOrders() {
      return this.totalRecords > 1;
    },
    canProceedToPayment() {
      return this.selectedDraftIds.length > 1;
    },
  },
  methods: {
    getSearchData(value) {
      this.order_date = value;
      this.getDraftOrderSearch();
    },

    async getDraftOrder() {
      this.loading = true;
      this.filter.s = this.order_date ? this.order_date[0] : "";
      this.filter.e = this.order_date ? this.order_date[1] : "";
      try {
        let res = await this.$store.dispatch(
          "Product/getDraftOrderAction",
          this.filter
        );
        this.draft_orders = res.data;
        this.totalRecords = res.meta.total;
        this.filter.page = res.meta.current_page;
        this.filter.per_page = res.meta.per_page;
        this.filter.last_page = res.meta.last_page;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },

    changePagination() {
      this.filter.page = 1;
      this.getDraftOrder();
    },

    getDraftOrderSearch() {
      this.filter.page = 1;
      this.getDraftOrder();
    },

    getSortedResults(column, order) {
      this.filter.columnTo = column;
      this.filter.orderBy = order;
      this.getDraftOrder();
    },

    async paySelectedDrafts() {
      if (!this.canProceedToPayment) {
        toast.error("Please select more than one draft order.", { timeout: 3000 });
        return;
      }

      this.payLoading = true;
      this.loading = true;
      this.loaderText = "Please wait while we are processing your request";
      await this.$nextTick();

      let checkoutStarted = false;
      try {
        for (const draftId of this.selectedDraftIds) {
          let draftRes;
          try {
            draftRes = await this.$store.dispatch("Link/getEditLinksDataAction", draftId);
          } catch (error) {
            swal.fire({
              icon: "error",
              title: "Oops...",
              text:
                error?.response?.data?.message ||
                `Draft order #${draftId} is no longer available.`,
            });
            return;
          }

          if (!draftRes?.draft_order) {
            swal.fire({
              icon: "error",
              title: "Oops...",
              text: `Draft order #${draftId} is no longer available.`,
            });
            return;
          }

          const validation = validateDraftOrder(draftRes.draft_order);
          if (!validation.valid) {
            swal.fire({
              icon: "error",
              title: "Oops...",
              text: validation.message,
            });
            return;
          }
        }

        const sessionRes = await this.$store.dispatch(
          "Product/createDraftCheckoutSessionAction",
          { draft_ids: this.selectedDraftIds }
        );

        if (!sessionRes?.success || !sessionRes.checkout_token) {
          toast.error(
            sessionRes?.message || "Unable to start checkout.",
            { timeout: 4000 }
          );
          return;
        }

        const checkoutQuery = { ...(this.$route.query || {}) };
        delete checkoutQuery.draft_ids;
        checkoutQuery.draft_checkout = sessionRes.checkout_token;

        this.$router.push({
          name: "order-summary",
          query: checkoutQuery,
        });
        checkoutStarted = true;
      } catch (error) {
        toast.error(
          error?.response?.data?.message || "Unable to start checkout.",
          { timeout: 4000 }
        );
      } finally {
        this.payLoading = false;
        if (!checkoutStarted) {
          this.loading = false;
          this.loaderText = "";
        }
      }
    },

    downloadFile() {
      const headers = [
        "Order Title",
        "Plan Submitted For",
        "Created By",
        "Updated By",
        "Approved By",
        "Updated At",
        "Total",
        "Total Links",
        "Type",
        "Date Created",
      ];

      const csvRows = [
        headers.map((header) => `"${header}"`).join(","),
        ...(this.draft_orders || []).map((row) =>
          [
            row.order_title,
            row.user_id,
            row.created_by,
            row.updated_by,
            row.approved_by,
            row.updated_at,
            `$${row.amount}`,
            getDraftLinksCount(row),
            row.order_status === "pending" ? "new plan" : row.order_status,
            row.date,
          ]
            .map((value) => `"${String(value ?? "").replace(/"/g, '""')}"`)
            .join(",")
        ),
      ];

      const csvFile = new Blob([csvRows.join("\n")], { type: "text/csv" });
      const downloadLink = document.createElement("a");
      downloadLink.download = "Draft-Order.csv";
      downloadLink.href = window.URL.createObjectURL(csvFile);
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(downloadLink.href);
    },
  },
};
</script>

